module.exports = __webpack_public_path__ + "img/svg - left girl.667078a4.svg";